<template>
  <div>
    <Modal v-model="userForm" :title="title" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
       
        <Row>
            <Col span="24">
                <FormItem label="姓名" prop="name" :class="{requireStar:true}" >
                  <Input v-model="formValidate.name"  ></Input>
                </FormItem>
            </Col>
        </Row>
       
         <Row>
            <Col span="24">
                <FormItem label="单位" prop="unit" :class="{requireStar:true}" >
                  <Input v-model="formValidate.unit"  ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <FormItem label="职位" prop="job" :class="{requireStar:true}" >
                  <Input v-model="formValidate.job"  ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <FormItem label="手机号" prop="phone" :class="{requireStar:true}" >
                  <Input v-model="formValidate.phone"  ></Input>
                </FormItem>
            </Col>
        </Row>
         <Row>
            <Col span="24">
                <FormItem label="邮箱" prop="email"  >
                  <Input v-model="formValidate.email"  ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <FormItem label="QQ" prop="qq"  >
                  <Input v-model="formValidate.qq" type="number" ></Input>
                </FormItem>
            </Col>
        </Row>
          <Row>
            <Col span="24">
                <FormItem label="微信号" prop="wechat"  >
                  <Input v-model="formValidate.wechat"  ></Input>
                </FormItem>
            </Col>
        </Row>
      
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Bus from '@/utils/bus.js'
  export default {
    components:{
    },
    data() {
      
      
      return {
        userForm: false,
        title:'',
        formValidate: {
          _id: '',
          name: '',
          unit: '',
          job: '',
          phone: '',
          email: '',
          qq: '',
          wechat: '',
          
        },
        ruleValidate: {
          name: [{
            required: true,
            message: '姓名不能为空',
            trigger: 'change'
          }],
          unit: [{
            required: true,
            message: '单位名称不能为空',
            trigger: 'change'
          }],
          phone: [
            {required: true, message: '手机号码不能为空',trigger: 'change'},
            { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" }
          ],
           email: [
             { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
          ],
         
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
      
      if(row!=null){
        this.formValidate =row
      }
        
      },
      
    
      
      handleSubmit(name) {
       
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url =  'api/address' 
            let myData = {
              type:1,
              _id: this.formValidate._id,
              name: this.formValidate.name,
              unit: this.formValidate.unit,
              job: this.formValidate.job,
              phone: this.formValidate.phone,
              email: this.formValidate.email,
              qq: this.formValidate.qq,
              wechat: this.formValidate.wechat,
              
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
             if (response.data.code == 200) {
                this.$Message.success(response.data.msg);
                this.$parent.loadPage();
              } else {
                 this.$Message.error(response.data.msg);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/mail/mailEdit.vue